import type { UUID } from '$domain/types';

export type IdentityKind = 'guest' | 'authenticated';

export interface Identity {
  kind: IdentityKind;
  userId: UUID;
  email?: string | null;
  displayName?: string | null;
}

export const GUEST_USER_ID_KEY = 'sq:guestUserId';
export const IDENTITY_KIND_KEY = 'sq:identityKind';